export const PlanHelper = {
    Billing_cycle: {
        Monthly: "monthly",
        Yearly: "yearly",
    },
    Billing_cycle_list: [
        {name: "Mensal", value: "monthly"},
        {name: "Anual", value: "yearly"}
    ],
    Translate: function(v){
        const res = this.Billing_cycle_list.filter(x => x.value == v);
        return res[0]?.name;
    }
}